import React from 'react';
import { YoutubeFilled } from '@ant-design/icons';
import PropTypes from 'prop-types';

export const YoutubeIcon = ({ color, fontSize }) => {
  return <YoutubeFilled theme="filled" style={{ color: color, fontSize: fontSize }} />;
};

YoutubeIcon.propTypes = {
  fontSize: PropTypes.string, //40px
  color: PropTypes.string, //#009DE6
};
YoutubeIcon.defaultProps = {
  fontSize: '30px',
  color: 'white',
};
